import { createSvgIcon } from '@mui/material/utils';
import React, { memo, useEffect, useRef } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#65C3FF', cx: '12', cy: '12', r: '12' }),
    React.createElement("text", { key: '1', fill: '#FFFFFF', x: '50%', y: '55%', alignmentBaseline: 'middle', dominantBaseline: 'middle', textAnchor: 'middle' }),
], 'TransportConditionSpeed');
const TransportConditionSpeedIcon = function (props) {
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const text = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector('text');
        if (text) {
            text.textContent = String(props.children);
        }
    });
    return (React.createElement(SvgIcon, Object.assign({ ref: ref, sx: (theme) => ({
            circle: {
                fill: props.color !== 'success' ? theme.palette.error.main : theme.palette.success.light,
            },
            text: {
                fontFamily: `"Roboto", sans-serif`,
                fontWeight: '500',
                fontSize: '13px',
            },
        }) }, props)));
};
export default memo(TransportConditionSpeedIcon);
